<style lang="scss" scoped>
img {
  min-width: 100%;
}

.hide-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 85%;
}
.icon {
  position: relative;
  bottom: 10px;
}

.avatar {
  display: block;
  position: relative;
  width: 100%;
  background-size: cover;

  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}
</style>

<template>
  <div class="row rounded profile-shortInfo">
    <div class="col-12 border shadow">
      <div class="row">
        <div class="col-12 bg-white profile-shortInfo-picture p-0">
          <a
            :href="profileUrl"
            class="avatar"
            :style="{ 'background-image': 'url(' + primaryImageUrl + ')' }"
          >
          </a>
        </div>
      </div>
      <div class="row bg-white pr-3 pl-3">
        <div class="col-12 pl-1 pt-2">
          <div class="row">
            <div class="col-12 text-primary">
              <a class="profile-name hide-overflow" :href="profileUrl">{{
                profile.name
              }}</a>
              <i
                class="pl-1 fas fa-circle icon"
                :class="{ 'text-success': isOnline, 'text-danger': !isOnline }"
              ></i>
            </div>
          </div>
          <div class="row">
            <div class="col-12 pt-0 text-primary pb-3">
              <label class="profile-friends"
                >Befreundet seid: <br />
                {{ friendsSince }}</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import { getDateTimeHtml } from "@/js/date";
export default {
  props:{
    profile: {
      required: true,
      type: Object
    },
  },
  methods: {
    storeId(){
      localStorage.setItem("last-id", this.id);
    }
  },
  computed: {
    isOnline() {
      return this.$store.getters["online/profileOnline"](this.profile.id);
    },
    primaryImageUrl() {
      return this.profile.primary_image.url + '?width=' + Laravel.settings.imagesize.memberSearchImages + '&height=' + Laravel.settings.imagesize.memberSearchImages;
    },
    profileUrl() {
      return `/mitglied/${this.profile.name}`;
    },
    friendsSince() {
      return getDateTimeHtml(this.profile.pivot.updated_at);
    }
  }
};
</script>
